//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconStatusFilter(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M3.52986 5H17.8599L12.9999 10.79V17.13L10.9999 18.28V10.79L7.81986 7H5.20986L8.99986 11.51V21.72L14.9999 18.29V11.51L22.1399 3H1.85986L3.52986 5Z" fill="currentColor" /></svg>;
}
export default IconStatusFilter;